$(function() {
    if($('#acf-form').length > 0) {
        let height,
            hasErrors = false

        // Additional Address Logic
        acf.addAction('show_field/name=additional_address', function(field) {
            let $fields = field.$el.parents('.acf-form-fields'),
                currentHeight = $fields.outerHeight()

            height = field.$el.outerHeight()
            $fields.animate({height: currentHeight + height})
        })

        acf.addAction('hide_field/name=additional_address', function(field) {
            let $fields = field.$el.parents('.acf-form-fields'),
                currentHeight = $fields.outerHeight(),
                $errors = $('#add_address').find('.acf-error-message'),
                errorHeight = 0

            if($errors.length > 0) {
                // Only calculate error height on first instance of showing up
                if(!hasErrors) {
                    $.each($errors, function(){
                        let $this = $(this).closest('.acf-field'),
                            error = 37

                        // Only add one inline field height
                        if($this.hasClass('sized-input') && $this.siblings('.sized-input.acf-error').length !== 0) { error = 0 }

                        errorHeight = errorHeight + error
                    })

                    hasErrors = true
                }
            }

            let newHeight = hasErrors ? currentHeight - height - errorHeight : currentHeight - height
            $fields.animate({height: newHeight})
            errorHeight = 0
        })

        // Validation on Step 3
        acf.addFilter('validation_complete', ( json, $form ) => {
            let $fields = $('.acf-form-fields.active'),
                currentHeight = $fields.outerHeight(),
                errorHeight = 0

            if( json.errors ) {
                $.each(json.errors, (k, v) => {
                    errorHeight = errorHeight + 37
                })
                $fields.animate({height: currentHeight + errorHeight })

                dataLayer.push({
                    'event' : 'hcformSubmit',
                    'hcformSubmit' : 'error'
                })
            } else {
                dataLayer.push({
                    'event' : 'hcformSubmit',
                    'hcformSubmit' : 'success'
                })
            }

            return json
        })

        // AJAX Call
        function renderPage() {
            let isValidating

            // initialize the acf script
            acf.doAction('ready', $('body'))

            acf.doAction('validation_begin', () => {
                isValidating = true
            })

            acf.addAction('submit', ($form) => {
                let $formContainer = $form.parents('.form-container')

                isValidating = false

                $form.on('submit', (e) => { e.preventDefault() })

                if(!isValidating) {
                    let data = acf.serialize($form)
                    data.action =  'acf/validate_save_post'
                    acf.lockForm($form)

                    $.ajax({
                        url: window.location.href,
                        data: acf.prepareForAjax(data),
                        dataType: 'json',
                        type: 'post',
                        success: (data) => {
                            acf.unlockForm($form)
                        },
                        complete: (data) => {
                            $formContainer.hide()
                            $formContainer.siblings('#thank-you').fadeIn()
                        }
                    })

                    return false
                }
            })
        }

        renderPage()
    }
})